// 日常生活動作トレーニング(ADL)詳細.
import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as Header from '../constants/Header';
import * as MoffAPI from '../constants/MoffAPI';
import * as TrainingConst from '../constants/Training';
import UserDetail, { DummyUserDetail } from './common/UserDetail';
import MonthlyHistory, { DummyMonthlyHistory } from './common/MonthlyHistory';
import DailyHistory, { DummyDailyHistory } from './common/DailyHistory';
import TrainingGraphs, { DummyTrainingGraphs } from './common/TrainingGraphs';
import { MDate } from '../utils/dateUtil';
import AdlLongTerm from './AdlLongTerm';
import { JS_VOID } from '../utils/commonUtil';
import { detect } from 'detect-browser';
import '../css/locomo.css';
import '../css/calendar.css';
import '../css/print.css';
import AdlCompare from './AdlCompare';
import { TrainingMenu, TYPE } from '../constants/Training';

// 印刷ボタンのCSS.
const printCss: React.CSSProperties = {
  marginLeft: '88.5%',
  // marginTop: '-8.5%'
  marginTop: '-5.5%'
};

// ローディング中のダミー・印刷のヘッダ部分.
class DummyPrintHeader extends React.Component {
  render() {
    return (
      <section id="sec01">
        <a
          href="#"
          className="btn btnStyle07"
          role="button"
        >
          長期変化をみる
        </a>
        <a
          href="#"
          onClick={event => {window.print(); return false; }}
          className="btn btn-default"
          role="button"
          style={printCss}
        >
          印刷 
        </a>
      </section>
    );
  }
}

// 詳細・印刷のヘッダのprops
interface PrintHeaderProps extends React.Props<{}> {
  user: any;
}

// 詳細・印刷のヘッダ部分.
class PrintHeader extends React.Component<PrintHeaderProps, {}> {
  static get contextTypes() {
    // 親のAdlコンポーネントと橋渡しするcontext.
    return {
      changeState: PropTypes.func
    };
  }

  // 長期変化をみるをクリックしたときの処理.
  toAdlLongterm = (userId: string) => {
    // 長期変化への導線.
    this.context.changeState(TrainingConst.LONG_TERM_STATE);
  }

  render() {
    return (
      <section id="sec01">
        <a
          href={JS_VOID}
          onClick={event => this.toAdlLongterm(this.props.user.user_id)}
          className="btn btnStyle07"
          role="button"
        >
          長期変化をみる
        </a>
        <a
          href={JS_VOID}
          onClick={event => {window.print(); return false; }}
          className="btn btn-default"
          role="button"
          style={printCss}
        >
          印刷 
        </a>
      </section>
    );
  }
}

interface AdlProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  headerActions?: any;

  // 前ページのユーザーID.
  match?: any;
}

interface AdlState {
  // 長期変化.
  adlState: number;
}

// 詳細本体.
export default class Adl extends React.Component<AdlProps, AdlState> {
  staticpropTypes = {
    moffAPI: PropTypes.any.isRequired,
    moffAPIActions: PropTypes.any.isRequired
  };  

  static get childContextTypes() {
    return {
      callbackParent: PropTypes.func,
      changeState: PropTypes.func,
    };
  }

  mDate: MDate;

  // 1度目のキャッシュ用.
  // 左右ボタン押下の時に毎回APIアクセスする必要のないマスター的なデータ.
  cachedTrainingMenus: TrainingMenu[];
  cachedUser: any;
  userId: string;

  constructor(props: AdlProps) {
    super(props);

    // デフォルトは詳細.
    this.state = {
      adlState: TrainingConst.DETAIL_STATE,
    };
  }

  // 子のMonthlyHistoryコンポーネントから呼ばれるcontext管理.
  getChildContext() {
    const callback: Function = (yearmonth: string) => {
      // 最初の2つのAPIはすでに最初に取得済みなのでここでは、getMonthlyDataしか行わない.
      // x getTraining();
      // x getUser(userId);
      // o getMonthlyData(1, userId, '2017-08');
      this.props.moffAPIActions.getMonthlyData(MoffAPI.ADL_TYPE, this.userId, yearmonth);
    };

    // ステートの切り替え.
    const changeState: Function = (state: number) => {
      switch (state) {
        case TrainingConst.DETAIL_STATE:
          // 通常のADL詳細.
          // 長期変化から詳細へ戻ったときの処理.
          // 再度現在のYearMonthで通信.
          this.mDate = new MDate();
          const yearmonth: string = this.mDate.yearmonth;
          this.props.moffAPIActions.getMonthlyData(MoffAPI.ADL_TYPE, this.userId, yearmonth);
          break;
        case TrainingConst.LONG_TERM_STATE:
          // 長期変化.
          break;
        case TrainingConst.COMPARE_STATE:
          // 比較.
          break;
        default:
          break;
      }

      this.setState({
        // 長期変化 or デフォルトの詳細.
        adlState: state
      });
    };

    return {
      callbackParent: callback,
      changeState: changeState,
    };
  }

  componentWillMount() {
    document.title = '利用者一覧';  

    this.props.headerActions.setPage(Header.ADL);

    // URLのパラメータ.
    this.userId = this.props.match.params.userId;

    this.mDate = new MDate();

    // '2017-08'の文字列の年月値.
    const yearmonth: string = this.mDate.yearmonth;

    // 3つを同時に行うAPI.
    // this.props.moffAPIActions.getTraining();
    // this.props.moffAPIActions.getUser(userId);
    // this.props.moffAPIActions.getMonthlyData(1, userId, '2017-08');
    this.props.moffAPIActions.getDetailData([
      null,
      this.userId,
      [MoffAPI.ADL_TYPE, this.userId, yearmonth]
    ]);
  }

  shouldComponentUpdate(nextProps: AdlProps, nextState: AdlState): boolean {
    return true;
  }

  render() {
    let articleClasName: string = 'report';
    if (this.state.adlState === TrainingConst.COMPARE_STATE) {
      // 比較の時だけクラス名が違う.
      articleClasName = 'report compare';
    }

    // APIより取得される項目.
    return (
      <div>
        <this.renderCSS />
        {
          (() => {
            if (this.props.moffAPI.Loaded) {
              // キャッシュさせておく.
              if (this.props.moffAPI.result.training) {
                this.cachedTrainingMenus = this.props.moffAPI.result.training;
              }

              if (this.props.moffAPI.result.user) {
                this.cachedUser = this.props.moffAPI.result.user;
              }

              return;
            }

            // ローディング中
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }
        <article className={articleClasName}>
          {(this.props.moffAPI.Loaded || this.cachedUser) ? 
            // ロードしたUserを表示
            // ロードした利用者の詳細
            <UserDetail user={this.props.moffAPI.result.user || this.cachedUser} /> 
            :
            <DummyUserDetail />
          }

          {
            (() => {
            if (this.state.adlState === TrainingConst.LONG_TERM_STATE) {
              // 長期変化.
              return <AdlLongTerm
                Loaded={this.props.moffAPI.Loaded}
                longTermData={this.props.moffAPI.result.longTermData}
                userId={this.userId}
                moffAPIActions={this.props.moffAPIActions}
                mDate={this.mDate}
              />;
            } else if (this.state.adlState === TrainingConst.COMPARE_STATE) {
              // 比較.
              return <AdlCompare 
                moffAPIActions={this.props.moffAPIActions}
                startData={this.props.moffAPI.result.startData}
                endData={this.props.moffAPI.result.endData}
                mDate={this.mDate}
                userId={this.userId}
                Loaded={this.props.moffAPI.Loaded}
                trainingMenus={this.props.moffAPI.result.training || this.cachedTrainingMenus}
              />;
            } else {
              // 詳細.
              if (this.props.moffAPI.Loaded) {
                return <div>
                  <PrintHeader
                    // 2度目はAPIから返ってこないのでキャッシュを使用.
                    user={this.props.moffAPI.result.user || this.cachedUser}
                  />
                  <MonthlyHistory
                    type={TYPE.ADL}
                    trainingMenus={this.props.moffAPI.result.training || this.cachedTrainingMenus}
                    history={this.props.moffAPI.result.monthlyData}
                    mDate={this.mDate}
                  />
                  <DailyHistory
                    type={TYPE.ADL}
                    trainingMenus={this.props.moffAPI.result.training || this.cachedTrainingMenus}
                    history={this.props.moffAPI.result.monthlyData}
                    mDate={this.mDate}
                  />
                  <TrainingGraphs
                    type={TYPE.ADL}
                    // 2度目はAPIから返ってこないのでキャッシュを使用.
                    history={this.props.moffAPI.result.monthlyData}
                    mDate={this.mDate}
                  />
                </div>;
              } else {
                return <div>
                  <DummyPrintHeader />
                  <DummyMonthlyHistory
                    mDate={this.mDate}
                  />
                  <DummyDailyHistory
                    mDate={this.mDate}
                  />
                  <DummyTrainingGraphs
                    type={TYPE.ADL}
                    mDate={this.mDate}
                  />
                </div>;
              }
            }
          })()
          }
        </article>
      </div>
    );
  }

  /**
   * CSSの描画.
   * A4横向き固定、ページはみ出る対策.
   *
   * @private
   * @returns {JSX.Element}
   * @memberof Locomo
   */
  private renderCSS(): JSX.Element {
    let margin = 'margin:0mm !important;';
    // Firefoxの印刷調整.
    const browser = detect();
    if (browser) {
      const name: string = browser.name;
      if (name === 'firefox') {
        margin = 'margin-left:10mm !important;'
          + 'margin-right:10mm !important;'
          + 'margin-top:0mm !important;'
          + 'margin-bottom:0mm !important;';
      }
    }
    return (
      <style key="locomoCSS" type="text/css">
        {'@media print { html, body { height: 100% !important; width: 100% !important; } '
        + '@page { size: A4 landscape !important; ' + margin +  ' padding:0mm !important; } '
        + '#wrapper .contentIn { min-height: 100% !important; margin:0mm !important; padding:0mm !important; '
        + 'height: 100% !important; width: 100% !important; } '
        + '.report { padding-bottom: 0 !important; } '
        + '}'}
      </style>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Adl.tsx